import { render } from "./ConfigureIntegrations.vue?vue&type=template&id=031c6d36"
import script from "./ConfigureIntegrations.vue?vue&type=script&lang=js"
export * from "./ConfigureIntegrations.vue?vue&type=script&lang=js"

import "./ConfigureIntegrations.vue?vue&type=style&index=0&id=031c6d36&lang=scss"
script.render = render

export default script